import { useState } from 'react';
import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import ViewEvents from './ViewEvents';

export const ViewEventsPage = () => {
  const [title, setTitle] = useState('Events');
  return (
    <Page
      title={title}
      sectionName="events"
      pageId={Pages.EVENTS}
      requireAuth
      breadcrumbs={['events']}
      disablePageLoader={true}
    >
      <ViewEvents setTitle={setTitle} />
    </Page>
  )
};

export default ViewEventsPage;
